module.exports = __webpack_public_path__ + "img/bcn-logo.54273c33.png";